/* eslint-disable */
<template>
  <div class="main-div" v-if="superUser() === true">
    <img :src="imgUrl" alt="login img"/>

    <div id="login-form">
      <div id="login-div">
        <div class="form-group">
          <b-form-input v-model="user_email" placeholder="user email"></b-form-input>
        </div>

        <div class="form-group">
          <b-form-input type="password" v-model="password" placeholder="password"></b-form-input>
        </div>

        <div class="form-group">
          <b-form-input  v-model="it_email" placeholder="Your real email address"></b-form-input>
        </div>

      </div>
      <div id="button-div">
        <b-button pill variant="success" @click="loginUser()">Super User Login</b-button>
      </div>
    </div>
  </div>
  <div v-else>
    <h1>This Page is for Admin User Only, Please go to AAD Login Page.</h1>
    <a class="btn btn-primary" target="_blank" :href="safeUrl(`${ $root.frontEndUrl}`)">Login</a>
  </div>
</template>

<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'login',
    data() {
      return {
        user_email: '',
        password: '',
        it_email: '',
        user_name: '',
        imgUrl: '../../static/image/logo_Getac.svg',
        options: '',
        frontEndUrlToUse: '',
      }
    },
    methods: {
      superUser() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_roles = this.$session.get('user_roles');
        if (user_roles && _.indexOf(user_roles, 'SuperAdmin') > -1) {
          return true;
        }
        else {
          return false;
        }
      },

      loginUser() {
        let self = this;
        this.$axios.post(self.$root.baseUrl + '/auth/login/', {
          user_email: self.user_email,
          password: self.password,
          it_email: self.it_email
        })
          .then((res) => {
            res = res.data
            console.log(res)
            if (res.status == 'ok') {
              var user_object = JSON.parse(res['user_object']);
              var option_object = res['options'];
              var mode = res['mode'];
              var version = res['version'];
              var release_notes = res['release_notes'];
              var eto_definition = res['eto_definition'];
              console.log(user_object);
              self.$store.commit('saveToken', { token: user_object.token, username: user_object.user_name, env: mode  });
              var url = self.$route.query.backUrl;
              self.user_name = user_object.user_name;
              self.user_email = user_object.user_id;
              self.options = option_object;
              self.$session.start();
              self.$session.set('user_id', user_object.user_id);
              self.$session.set('user_name', user_object.user_name);
              self.$session.set('user_site', user_object.regions);
              self.$session.set('user_roles', user_object.roles);
              self.$session.set('user_functions', user_object.functions);
              self.$session.set('options', option_object);
              self.$session.set('release_notes', release_notes);
              self.$session.set('eto_definition', eto_definition);
              self.$session.set('mode', mode);
              self.$session.set('version', version);
              self.frontEndUrlToUse = self.$options.filters['frontendUrlbyRoles']('Home', user_object.user_name, user_object.roles, user_object.functions, user_object.regions);
              self.$session.set('frontEndUrlToUse', self.frontEndUrlToUse);
              self.$router.push('home');
            } else {
              self.$message.error(res.description);
              //console.log(res);
            }

          })
          .catch(function (error) {
            if (error.response) {
              console.log(error);
            }
          }
          )
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue